import createIcon from '../../createIcon';

/**
 * @component @name TransferWithinAStation
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTYuNDkgMTUuMjVWMTMuNUwxNCAxNkwxNi40OSAxOC41VjE2Ljc1SDIyVjE1LjI1SDE2LjQ5Wk0xOS41MSAxOS41SDE0VjIxSDE5LjUxVjIyLjc1TDIyIDIwLjI1TDE5LjUxIDE3Ljc1VjE5LjVaTTkuNSA1LjI1QzEwLjYgNS4yNSAxMS41IDQuMzUgMTEuNSAzLjI1QzExLjUgMi4xNSAxMC42IDEuMjUgOS41IDEuMjVDOC40IDEuMjUgNy41IDIuMTUgNy41IDMuMjVDNy41IDQuMzUgOC40IDUuMjUgOS41IDUuMjVaTTUuNzUgOC42NUwzIDIyLjc1SDUuMUw2Ljg1IDE0Ljc1TDkgMTYuNzVWMjIuNzVIMTFWMTUuMkw4Ljk1IDEzLjE1TDkuNTUgMTAuMTVDMTAuODUgMTEuNzUgMTIuOCAxMi43NSAxNSAxMi43NVYxMC43NUMxMy4xNSAxMC43NSAxMS41NSA5Ljc1IDEwLjY1IDguM0w5LjcgNi43QzkuMzUgNi4xIDguNyA1Ljc1IDggNS43NUM3Ljc1IDUuNzUgNy41IDUuOCA3LjI1IDUuOUwyIDguMDVWMTIuNzVINFY5LjRMNS43NSA4LjY1WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const TransferWithinAStation = createIcon('TransferWithinAStation', [
  [
    'path',
    {
      d: 'M16.49 15.25V13.5L14 16L16.49 18.5V16.75H22V15.25H16.49ZM19.51 19.5H14V21H19.51V22.75L22 20.25L19.51 17.75V19.5ZM9.5 5.25C10.6 5.25 11.5 4.35 11.5 3.25C11.5 2.15 10.6 1.25 9.5 1.25C8.4 1.25 7.5 2.15 7.5 3.25C7.5 4.35 8.4 5.25 9.5 5.25ZM5.75 8.65L3 22.75H5.1L6.85 14.75L9 16.75V22.75H11V15.2L8.95 13.15L9.55 10.15C10.85 11.75 12.8 12.75 15 12.75V10.75C13.15 10.75 11.55 9.75 10.65 8.3L9.7 6.7C9.35 6.1 8.7 5.75 8 5.75C7.75 5.75 7.5 5.8 7.25 5.9L2 8.05V12.75H4V9.4L5.75 8.65Z',
      key: '140qsc',
    },
  ],
]);

export default TransferWithinAStation;
